export default [
  {
    watch: 'watch-silver-1',
    name: '銀色面盤年曆腕錶',
    intro: '年曆功能自動辨識及調校30天與31天的大小月份，無需人工調整。配備全新L897自動上鏈機芯，具有64小時動力儲存，銀色麥穗紋錶面搭配阿拉伯數字時標，是優雅設計與精緻工藝的完美結合。',
    price: '73,000'
  },
  {
    watch: 'watch-blue',
    name: '藍色面盤年曆腕錶',
    intro: '年曆功能自動辨識及調校30天與31天的大小月份，無需人工調整。配備全新 L897自動上鏈機芯，具有64小時動力儲存，藍色太陽紋錶面搭配棒形時標，是優雅設計與精緻工藝的完美結合。',
    price: '75,400'
  },
  {
    watch: 'watch-black',
    name: '黑色面盤年曆腕錶',
    intro: '年曆功能自動辨識及調校30天與31天的大小月份，無需人工調整。配備全新L897自動上鏈機芯，具有64小時動力儲存，黑色麥穗紋錶面搭配羅馬數字時標，是優雅設計與精緻工藝的完美結合。',
    price: '73,000'
  },
  {
    watch: 'watch-silver-2',
    name: '銀色面盤點鑽時標年曆腕錶',
    intro: '年曆功能自動辨識及調校30天與31天的大小月份，無需人工調整。配備全新 L897自動上鏈機芯，具有64小時動力儲存，銀色麥穗紋錶面搭配點鑽時標，是優雅設計與精緻工藝的完美結合。',
    price: '85,100'
  }
]
